// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* upskld_head_pg_ - Header Component */

.upskld_head_pg_header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background-color: transparent;
  transition: background-color 0.4s ease, box-shadow 0.4s ease;
}

.upskld_head_pg_header.upskld_head_pg_scrolled {
  background-color: #ffffff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.upskld_head_pg_container {
  max-width: 1280px;
  margin: 0 auto;
  height: 70px;
  padding: 14px 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Logo */
.upskld_head_pg_logo_wrap {
  display: flex;
  align-items: center;
}

.upskld_head_pg_logo_link {
  display: flex;
  align-items: center;
}

.upskld_head_pg_logo_img {
  height: 160px;
  width: auto;
}

/* Desktop Nav */
.upskld_head_pg_nav_desktop {
  display: flex;
  align-items: center;
}

.upskld_head_pg_nav_list {
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 36px;
}

.upskld_head_pg_nav_item {
  display: flex;
  align-items: center;
}

.upskld_head_pg_nav_link {
  color: #000000;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  font-family: 'Manrope', sans-serif;
  transition: opacity 0.3s ease;
}

.upskld_head_pg_nav_link:hover {
  opacity: 0.6;
}

.upskld_head_pg_login_link {
  padding: 8px 22px;
  border: 1.5px solid #000000;
  border-radius: 30px;
}

/* Profile Icon + Accordion */
.upskld_head_pg_profile_wrap {
  position: relative;
}

.upskld_head_pg_profile_btn {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.upskld_head_pg_profile_icon {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  object-fit: cover;
  border: 1.5px solid #000000;
}

.upskld_head_pg_profile_accordion {
  position: absolute;
  top: calc(100% + 12px);
  right: 0;
  width: 180px;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  max-height: 0;
  opacity: 0;
  transition: max-height 0.3s ease, opacity 0.3s ease;
}

.upskld_head_pg_profile_accordion.upskld_head_pg_profile_accordion_open {
  max-height: 120px;
  opacity: 1;
}

.upskld_head_pg_accordion_item {
  display: block;
  width: 100%;
  text-align: left;
  padding: 12px 18px;
  background: none;
  border: none;
  font-size: 14.5px;
  font-weight: 500;
  font-family: 'Manrope', sans-serif;
  color: #000000;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.upskld_head_pg_accordion_item:hover {
  background-color: #f3f4f6;
}

.upskld_head_pg_accordion_logout {
  color: #d92d20;
  border-top: 1px solid #eee;
}

/* Mobile Menu Icon */
.upskld_head_pg_menu_icon {
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  z-index: 1100;
}

.upskld_head_pg_bar {
  width: 26px;
  height: 2.5px;
  background-color: #000000;
  border-radius: 2px;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.upskld_head_pg_menu_icon.upskld_head_pg_menu_open .upskld_head_pg_bar:nth-child(1) {
  transform: translateY(7.5px) rotate(45deg);
}

.upskld_head_pg_menu_icon.upskld_head_pg_menu_open .upskld_head_pg_bar:nth-child(2) {
  opacity: 0;
}

.upskld_head_pg_menu_icon.upskld_head_pg_menu_open .upskld_head_pg_bar:nth-child(3) {
  transform: translateY(-7.5px) rotate(-45deg);
}

/* Mobile Nav */
.upskld_head_pg_nav_mobile {
  max-height: 0;
  overflow: hidden;
  background-color: #ffffff;
  transition: max-height 0.4s ease;
}

.upskld_head_pg_nav_mobile.upskld_head_pg_nav_mobile_active {
  max-height: 300px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.upskld_head_pg_nav_mobile_list {
  list-style: none;
  margin: 0;
  padding: 12px 32px 20px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.upskld_head_pg_nav_mobile_link {
  color: #000000;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  font-family: 'Manrope', sans-serif;
  display: block;
}

.upskld_head_pg_mobile_action_btn {
  background: none;
  border: none;
  padding: 0;
  text-align: left;
  cursor: pointer;
  font-family: 'Manrope', sans-serif;
}

/* Tablet */
@media (max-width: 992px) {
  .upskld_head_pg_nav_desktop {
    display: none;
  }

  .upskld_head_pg_menu_icon {
    display: flex;
  }

  .upskld_head_pg_container {
    padding: 12px 24px;
  }

  .upskld_head_pg_logo_img {
    height: 142px;
  }
}

/* Mobile */
@media (max-width: 480px) {
  .upskld_head_pg_container {
    padding: 10px 18px;
  }

  .upskld_head_pg_logo_img {
    height: 114px;
  }
}

/* Small Android - 360px minimum */
@media (max-width: 360px) {
  .upskld_head_pg_container {
    padding: 8px 14px;
  }

  .upskld_head_pg_logo_img {
    height: 88px;
  }

  .upskld_head_pg_nav_mobile_list {
    padding: 10px 14px 16px;
    gap: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/HeadFoot/HeaderPage/HeaderPage.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAEvC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,4DAA4D;AAC9D;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,mDAAmD;AACrD;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,eAAe;AACf;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA,WAAW;AACX;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,WAAW;AACX;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,SAAS;EACX;AACF","sourcesContent":["/* upskld_head_pg_ - Header Component */\n\n.upskld_head_pg_header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 1000;\n  background-color: transparent;\n  transition: background-color 0.4s ease, box-shadow 0.4s ease;\n}\n\n.upskld_head_pg_header.upskld_head_pg_scrolled {\n  background-color: #ffffff;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);\n}\n\n.upskld_head_pg_container {\n  max-width: 1280px;\n  margin: 0 auto;\n  height: 70px;\n  padding: 14px 32px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n/* Logo */\n.upskld_head_pg_logo_wrap {\n  display: flex;\n  align-items: center;\n}\n\n.upskld_head_pg_logo_link {\n  display: flex;\n  align-items: center;\n}\n\n.upskld_head_pg_logo_img {\n  height: 160px;\n  width: auto;\n}\n\n/* Desktop Nav */\n.upskld_head_pg_nav_desktop {\n  display: flex;\n  align-items: center;\n}\n\n.upskld_head_pg_nav_list {\n  display: flex;\n  align-items: center;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  gap: 36px;\n}\n\n.upskld_head_pg_nav_item {\n  display: flex;\n  align-items: center;\n}\n\n.upskld_head_pg_nav_link {\n  color: #000000;\n  text-decoration: none;\n  font-size: 16px;\n  font-weight: 500;\n  font-family: 'Manrope', sans-serif;\n  transition: opacity 0.3s ease;\n}\n\n.upskld_head_pg_nav_link:hover {\n  opacity: 0.6;\n}\n\n.upskld_head_pg_login_link {\n  padding: 8px 22px;\n  border: 1.5px solid #000000;\n  border-radius: 30px;\n}\n\n/* Profile Icon + Accordion */\n.upskld_head_pg_profile_wrap {\n  position: relative;\n}\n\n.upskld_head_pg_profile_btn {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n.upskld_head_pg_profile_icon {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 1.5px solid #000000;\n}\n\n.upskld_head_pg_profile_accordion {\n  position: absolute;\n  top: calc(100% + 12px);\n  right: 0;\n  width: 180px;\n  background-color: #ffffff;\n  border-radius: 10px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n  overflow: hidden;\n  max-height: 0;\n  opacity: 0;\n  transition: max-height 0.3s ease, opacity 0.3s ease;\n}\n\n.upskld_head_pg_profile_accordion.upskld_head_pg_profile_accordion_open {\n  max-height: 120px;\n  opacity: 1;\n}\n\n.upskld_head_pg_accordion_item {\n  display: block;\n  width: 100%;\n  text-align: left;\n  padding: 12px 18px;\n  background: none;\n  border: none;\n  font-size: 14.5px;\n  font-weight: 500;\n  font-family: 'Manrope', sans-serif;\n  color: #000000;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.upskld_head_pg_accordion_item:hover {\n  background-color: #f3f4f6;\n}\n\n.upskld_head_pg_accordion_logout {\n  color: #d92d20;\n  border-top: 1px solid #eee;\n}\n\n/* Mobile Menu Icon */\n.upskld_head_pg_menu_icon {\n  display: none;\n  flex-direction: column;\n  justify-content: center;\n  gap: 5px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 6px;\n  z-index: 1100;\n}\n\n.upskld_head_pg_bar {\n  width: 26px;\n  height: 2.5px;\n  background-color: #000000;\n  border-radius: 2px;\n  transition: transform 0.3s ease, opacity 0.3s ease;\n}\n\n.upskld_head_pg_menu_icon.upskld_head_pg_menu_open .upskld_head_pg_bar:nth-child(1) {\n  transform: translateY(7.5px) rotate(45deg);\n}\n\n.upskld_head_pg_menu_icon.upskld_head_pg_menu_open .upskld_head_pg_bar:nth-child(2) {\n  opacity: 0;\n}\n\n.upskld_head_pg_menu_icon.upskld_head_pg_menu_open .upskld_head_pg_bar:nth-child(3) {\n  transform: translateY(-7.5px) rotate(-45deg);\n}\n\n/* Mobile Nav */\n.upskld_head_pg_nav_mobile {\n  max-height: 0;\n  overflow: hidden;\n  background-color: #ffffff;\n  transition: max-height 0.4s ease;\n}\n\n.upskld_head_pg_nav_mobile.upskld_head_pg_nav_mobile_active {\n  max-height: 300px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);\n}\n\n.upskld_head_pg_nav_mobile_list {\n  list-style: none;\n  margin: 0;\n  padding: 12px 32px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.upskld_head_pg_nav_mobile_link {\n  color: #000000;\n  text-decoration: none;\n  font-size: 16px;\n  font-weight: 500;\n  font-family: 'Manrope', sans-serif;\n  display: block;\n}\n\n.upskld_head_pg_mobile_action_btn {\n  background: none;\n  border: none;\n  padding: 0;\n  text-align: left;\n  cursor: pointer;\n  font-family: 'Manrope', sans-serif;\n}\n\n/* Tablet */\n@media (max-width: 992px) {\n  .upskld_head_pg_nav_desktop {\n    display: none;\n  }\n\n  .upskld_head_pg_menu_icon {\n    display: flex;\n  }\n\n  .upskld_head_pg_container {\n    padding: 12px 24px;\n  }\n\n  .upskld_head_pg_logo_img {\n    height: 142px;\n  }\n}\n\n/* Mobile */\n@media (max-width: 480px) {\n  .upskld_head_pg_container {\n    padding: 10px 18px;\n  }\n\n  .upskld_head_pg_logo_img {\n    height: 114px;\n  }\n}\n\n/* Small Android - 360px minimum */\n@media (max-width: 360px) {\n  .upskld_head_pg_container {\n    padding: 8px 14px;\n  }\n\n  .upskld_head_pg_logo_img {\n    height: 88px;\n  }\n\n  .upskld_head_pg_nav_mobile_list {\n    padding: 10px 14px 16px;\n    gap: 14px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
